/**
 * Centralized Pagination Configuration for Enterprise LIMS
 * Single source of truth for all tables, grids, and worklists across the application.
 */

export const PAGINATION_CONFIG = {
  // Central default page size
  defaultPageSize: 15,

  // Centralized allowed page size options
  pageSizeOptions: [15, 25, 30, 50, 100],

  // Maximum number of visible numbered buttons before adding ellipsis (...)
  maxVisiblePages: 5,

  // Standardized terminology and labels
  labels: {
    rowsPerPage: 'Rows per page',
    showing: (start, end, total) => `Showing ${start}–${end} of ${total} records`,
    showingEmpty: 'Showing 0–0 of 0 records',
    noRecords: 'No records found.',
    noFilteredRecords: 'No records matching your search or filter criteria.',
    first: 'First',
    previous: 'Previous',
    next: 'Next',
    last: 'Last',
    firstShort: '« First',
    prevShort: '‹ Prev',
    nextShort: 'Next ›',
    lastShort: 'Last »',
    pageOf: (current, total) => `Page ${current} of ${total}`,
  },
};

export default PAGINATION_CONFIG;
